import { render, staticRenderFns } from "./PayorSearch.vue?vue&type=template&id=5b626d57&scoped=true"
import script from "./PayorSearch.vue?vue&type=script&lang=js"
export * from "./PayorSearch.vue?vue&type=script&lang=js"
import style0 from "./PayorSearch.vue?vue&type=style&index=0&id=5b626d57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b626d57",
  null
  
)

export default component.exports